import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const Kicked = () => {
    useEffect(() => {
        document.title = 'Kicked'
    }, [])
    return (
        <div id='kicked'>
            <p>You Have Been Kicked</p>
            <Link className='kbl' to='/'>
                <button>OK</button>
            </Link>

        </div>
    )
}

export default Kicked
